export default __webpack_public_path__ + "static/noissue-101-left-087340c92ca8ff71f4f54f15cf8045bb.svg";